const menu = [
  {
    id: 1,
    title: 'Goodfellas',
    category: 'Crime/Drama',
    year: 1990,
    img: './images/item-1.jpeg',
    desc: `Young Henry Hill, with his friends Jimmy and Tommy, begins the climb from being a petty criminal to a gangster on the mean streets of New York.`,
  },
  {
    id: 2,
    title: 'The Wizard of Oz',
    category: 'Musical',
    year: 1939,
    img: './images/item-2.jpeg',
    desc: `When a tornado rips through Kansas, Dorothy (Judy Garland) and her dog, Toto, are whisked away in their house to the magical land of Oz. They follow the Yellow Brick Road toward the Emerald City to meet the Wizard, and en route they meet a Scarecrow (Ray Bolger) that needs a brain, a Tin Man (Jack Haley) missing a heart, and a Cowardly Lion (Bert Lahr) who wants courage. The wizard asks the group to bring him the broom of the Wicked Witch of the West (Margaret Hamilton) to earn his help. `,
  },
  {
    id: 3,
    title: 'Taxi Driver',
    category: 'Crime/Drama',
    year: 1976,
    img: './images/item-3.jpeg',
    desc: `Travis, an ex-marine and Vietnam veteran, works as a taxi driver in New York City. One day, he decides to save an underage prostitute from her pimp in an effort to clean the city of its corruption.`,
  },
  {
    id: 4,
    title: 'Ratatouille',
    category: 'Family/Comedy',
    year: 2007,
    img: './images/item-4.jpeg',
    desc: `Remy, a rat, aspires to become a renowned French chef. However, he fails to realise that people despise rodents and will never enjoy a meal cooked by him.`,
  },
  {
    id: 5,
    title: 'Inside Out',
    category: 'Family/Comedy',
    year: 2015,
    img: './images/item-5.jpeg',
    desc: `Eleven-year-old Riley moves to San Francisco, leaving behind her life in Minnesota. She and her five core emotions, Fear, Anger, Joy, Disgust and Sadness, struggle to cope with her new life. `,
  },
  {
    id: 6,
    title: 'Dune',
    category: 'Crime/Drama',
    year: 2021,
    img: './images/item-6.jpeg',
    desc: `Paul Atreides arrives on Arrakis after his father accepts the stewardship of the dangerous planet. However, chaos ensues after a betrayal as forces clash to control melange, a precious resource.`,
  },
  {
    id: 7,
    title: 'The Lion King',
    category: 'Musical',
    year: 1994,
    img: './images/item-7.jpeg',
    desc: `As a cub, Simba is forced to leave the Pride Lands after his father Mufasa is murdered by his wicked uncle, Scar. Years later, he returns as a young lion to reclaim his throne.`,
  },
  {
    id: 8,
    title: 'Fight Club',
    category: 'Family/Comedy',
    year: 1999,
    img: './images/item-8.jpeg',
    desc: `Unhappy with his capitalistic lifestyle, a white-collared insomniac forms an underground fight club with Tyler, a careless soap salesman. Soon, their venture spirals down into something sinister. `,
  },
  {
    id: 9,
    title: 'E.T.',
    category: 'Family/Comedy',
    year: 1982,
    img: './images/item-9.jpeg',
    desc: `An alien is left behind on Earth and is saved by young Elliot who decides to keep him hidden. While the task force hunts for it, Elliot and his siblings form an emotional bond with their new friend.`,
  },
];
export default menu;
